import { $axios, dealWithErrors, dealWithSuccess } from '../import/http'
import store from '@/store'
import filter from '../import/filter'

const filteredKeys = [
  {
    path: '',
    loop: false,
    keys: [
      {
        key: 'dly_id',
        type: 'int',
      },
      {
        key: 'dly_is_active',
        type: 'bool',
      },
    ],
  },
  {
    path: 'current_history.',
    loop: false,
    keys: [
      {
        key: 'dhy_is_sum_weight_price',
        type: 'bool',
      },
      {
        key: 'dhy_date_from',
        type: 'date',
      },
      {
        key: 'languages[0].pivot.dhe_name',
        type: 'string',
      },
    ],
  },
]

export default {
  namespaced: true,
  state: {
    items: [],
    detail: {
      current_history: {
        languages: [],
      },
    },
  },
  mutations: {
    SET_ITEMS(state, items) {
      state.items = items
    },
    SET_CURRENT(state, items) {
      const index = state.items.indexOf(state.items.find(x => x.lge_id === store.getters['language/active']))
      if (index !== -1) {
        state.items.splice(index, 1)
      }
      state.items.push(items)
    },
    SET_CURRENT_DETAIL(state, item) {
      const index = state.detail.current_history.languages.indexOf(state.detail.current_history.languages.find(x => x.lge_id === store.getters['language/active']))
      const oldLang = state.detail.current_history.languages
      const newItem = {
        lge_id: store.getters['language/active'],
        dhe_name: item.current_history.languages.length > 0 ? item.current_history.languages[0].pivot.dhe_name : undefined,
      }
      state.detail = Object.assign({}, item)
      state.detail.current_history.languages = oldLang
      if (index !== -1) {
        state.detail.current_history.languages.splice(index, 1)
      }
      state.detail.current_history.languages.push(newItem)
      state.detail.payments = item.payments.map(x => x.pmt_id)
    },
    UPDATE_STATE(state, payload) {
      state.items.forEach((value, key) => {
        for (let i = 0; i < value.data.length; i++) {
          if (payload.items.includes(value.data[i].dly_id)) {
            state.items[key].data[i].dly_is_active = payload.activated
          }
        }
      })
    },
  },
  actions: {
    getList({ commit }) {
      return new Promise((resolve, reject) => {
        $axios.get('/delivery/lang/' + store.getters['language/active'], {
          headers: {
            Accept: 'application/json',
            Authorization: 'Bearer ' + store.state.token.access_token,
          },
        }).then(response => {
          commit('SET_CURRENT', response.data)
          resolve(response)
        }).catch(error => {
          dealWithErrors(error)
          reject(error)
        })
      })
    },
    getOne({ commit }, id) {
      return new Promise((resolve, reject) => {
        $axios.get('/delivery/' + id + '/lang/' + store.getters['language/active'], {
          headers: {
            Accept: 'application/json',
            Authorization: 'Bearer ' + store.state.token.access_token,
          },
        }).then(response => {
          commit('SET_CURRENT_DETAIL', response.data)
          resolve(response)
        }).catch(error => {
          dealWithErrors(error)
          reject(error)
        })
      })
    },
    deactivate({ commit }, items) {
      return new Promise((resolve, reject) => {
        $axios.delete('/delivery', {
          headers: {
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + store.state.token.access_token,
          },
          data: { data: items.map(x => { return { dly_id: x } }) },
        }).then(() => {
          commit('UPDATE_STATE', { items: items, activated: false })
          resolve()
          dealWithSuccess({ message: 'OK!', description: 'Deaktivace proběhla v pořádku.' })
        }).catch(error => {
          dealWithErrors(error)
          reject(error)
        })
      })
    },
    post({ commit }, items) {
      return new Promise((resolve, reject) => {
        $axios.post('/delivery', { data: items }, {
          headers: {
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + store.state.token.access_token,
          },
        }).then(() => {
          resolve()
          dealWithSuccess({ message: 'OK!', description: 'Vytvoření proběhlo v pořádku.' })
        }).catch(error => {
          dealWithErrors(error)
          reject(error)
        })
      })
    },
    put({ commit }, { id, item }) {
      return new Promise((resolve, reject) => {
        $axios.put('/delivery/' + id, { data: item }, {
          headers: {
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + store.state.token.access_token,
          },
        }).then((response) => {
          resolve()
          dealWithSuccess({ data: response.data.data, message: 'OK!', description: 'Upravení proběhlo v pořádku.' })
        }).catch(error => {
          dealWithErrors(error)
          reject(error)
        })
      })
    },
    activate({ commit }, id) {
      return new Promise((resolve, reject) => {
        $axios.patch('/delivery/' + id, {}, {
          headers: {
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + store.state.token.access_token,
          },
        }).then((response) => {
          commit('UPDATE_STATE', { items: id, activated: true })
          resolve()
          dealWithSuccess({ data: response.data.data, message: 'OK!', description: 'Aktivace proběhla v pořádku.' })
        }).catch(error => {
          dealWithErrors(error)
          reject(error)
        })
      })
    },
  },
  getters: {
    allItems: state => state.items,
    currentLanguage: (state) => (searchText = '') => {
      const activeItems = state.items.filter(x => x.lge_id === store.getters['language/active'])
      const currentItems = store.getters['language/active'] !== null && activeItems.length !== 0 && activeItems[0].data !== undefined ? activeItems[0].data : []
      if (searchText.length > 0) {
        return filter.methods.filterItems(currentItems, filteredKeys, searchText)
      }
      return currentItems
    },
    byLanguage: (state) => (searchText = '', language) => {
      const activeItems = state.items.filter(x => x.lge_id === language)
      return language !== null && activeItems.length !== 0 && activeItems[0].data !== undefined ? activeItems[0].data : []
    },
    currentLanguageDetail: (state) => {
      return state.detail.current_history.languages !== undefined ? state.detail.current_history.languages.find(x => x.lge_id === store.getters['language/active']) : undefined
    },
    getDetail: (state) => {
      return state.detail
    },
  },
}
